import React, { useEffect } from 'react';
import { initFacebookPixel, trackPixelEvent } from './components/analytics/fbpixel';
import { HeroSection } from './components/sections/HeroSection';
import { ProblemSection } from './components/sections/ProblemSection';
import { TomosSection } from './components/sections/TomosSection';
import { BonusSection } from './components/sections/BonusSection';
import { PricingSection } from './components/sections/PricingSection';
import { SocialProofSection } from './components/sections/SocialProofSection';
import { FAQSection } from './components/sections/FAQSection';
import { FooterSection } from './components/sections/FooterSection';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    initFacebookPixel();
    trackPixelEvent('PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-rose-200 selection:text-rose-900" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <TomosSection data-id="element-3" />
      <BonusSection data-id="element-4" />
      <PricingSection data-id="element-5" />
      <SocialProofSection data-id="element-6" />
      <FAQSection data-id="element-7" />
      <FooterSection data-id="element-8" />
      <PurchasePopup data-id="element-9" />
    </div>;
}